import qs from 'qs';
import { fetchGET, fetchPOST } from 'api/fetchHelper';

const PATH = '/_api/v1/chat_rooms';

const ChatRooms = {
  getAll: ({ page, include, filter, fields, signal } = {}) => (
    fetchGET(`${PATH}?${qs.stringify({ page, include, filter, fields }, { encodeValuesOnly: true })}`, signal)
  ),
  start: ({ chatRoomId, include } = {}) => {
    if (!chatRoomId) throw new Error('chatRoomId is not defined');

    const queryString = qs.stringify({ include }, { encodeValuesOnly: true });
    return fetchPOST(`${PATH}/${chatRoomId}/start?${queryString}`);
  },
  finish: ({ chatRoomId, include } = {}) => {
    if (!chatRoomId) throw new Error('chatRoomId is not defined');

    const queryString = qs.stringify({ include }, { encodeValuesOnly: true });
    return fetchPOST(`${PATH}/${chatRoomId}/finish?${queryString}`);
  },
  moveCursor: ({ chatRoomId, include, messageId } = {}) => {
    if (!chatRoomId) throw new Error('chatRoomId is not defined');

    const queryString = qs.stringify({ include, message_id: messageId }, { encodeValuesOnly: true });
    return fetchPOST(`${PATH}/${chatRoomId}/move_cursor?${queryString}`);
  },
};

export default ChatRooms;
